import { Component, OnInit, Input } from '@angular/core';
import { ComponentType, ComponentPortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-menu-popup',
  templateUrl: './menu-popup.component.html',
  styleUrls: ['./menu-popup.component.scss']
})
export class MenuPopupComponent implements OnInit {

  @Input()
  component: ComponentType<any>;

  componentPortal: ComponentPortal<any>;

  constructor() { }

  ngOnInit(): void {
    this.componentPortal = new ComponentPortal(this.component);
  }

}
